import React from 'react';
import { TextField } from '@material-ui/core';
import AddressAutocomplete from '@/components/ShipmentForm/ModifiedAddressAutocomplete';
import { toFullState } from '@/utilities/address';
import { Fieldset } from './blocks';

/**
 * Address block, shared by both forms.
 *
 * The two forms disable different fields and that difference is deliberate, so the flags are
 * explicit rather than derived:
 *   · first-location form — City and Zip are read-only, filled by the autocomplete
 *   · edit form           — City and Zip are editable (subject to viewOnly)
 * State is read-only in both, and always shown expanded to its full name.
 */
const AddressFields = ({ chosen, hasError, viewOnly, cityLocked, zipLocked, onAddressUpdate, patch }) => (
    <>
        <AddressAutocomplete
            state={{
                street: chosen.business_address || '',
                city: chosen.business_city || '',
                state: chosen.business_state || '',
                zip: chosen.business_zip || '',
            }}
            handleAddressUpdate={onAddressUpdate}
        />

        <Fieldset columns={4}>
            <TextField
                fullWidth
                variant="outlined"
                id="store-city"
                label="City"
                value={chosen.business_city || ''}
                error={hasError.business_city}
                disabled={cityLocked || viewOnly}
                InputLabelProps={{ shrink: !!chosen.business_city }}
                onChange={(e) => patch({ business_city: e.target.value })}
            />
            <TextField
                fullWidth
                disabled
                variant="outlined"
                id="store-state"
                label="State"
                value={toFullState(chosen.business_state) || ''}
                error={hasError.business_state}
                InputLabelProps={{ shrink: !!chosen.business_state }}
            />
            <TextField
                fullWidth
                variant="outlined"
                id="store-zip"
                label="Zip Code"
                type="number"
                value={chosen.business_zip || ''}
                error={hasError.business_zip}
                disabled={zipLocked || viewOnly}
                InputLabelProps={{ shrink: !!chosen.business_zip }}
                onChange={(e) => patch({ business_zip: e.target.value })}
            />
            <TextField
                fullWidth
                variant="outlined"
                color="primary"
                id="store-unit"
                label="Unit/Ste #"
                name="apartmentNumber"
                value={chosen.business_unit || ''}
                disabled={viewOnly}
                InputLabelProps={{ shrink: !!chosen.business_unit }}
                onChange={(e) => patch({ business_unit: e.target.value })}
            />
        </Fieldset>
    </>
);

export default AddressFields;
